/**
 * E17 (QUALITY-NCR-REVIEW E2E run): name the missing 8D grades before the
 * approve dialog opens, instead of after the confirm when the server refuses.
 * Labels match the server's message (quality/views/ncr_views/_actions_decisions.py).
 */
interface CarScores {
  rcScore?: number | null;
  ercScore?: number | null;
  caScore?: number | null;
  epaScore?: number | null;
}

/**
 * The grades still to give, in review order.
 *
 * @param scores - the grades on screen
 * @param escapeChain - the customer scores the Escape pair too
 * @returns the names of the missing grades; empty when all are given
 */
export function missingCarScores(scores: CarScores, escapeChain: boolean): string[] {
  const fields: [number | null | undefined, string, boolean][] = [
    [scores.rcScore, 'Occurrence Root Cause', true],
    [scores.ercScore, 'Escape Root Cause', escapeChain],
    [scores.caScore, 'Occurrence Prevention Actions', true],
    [scores.epaScore, 'Escape Prevention Actions', escapeChain],
  ];
  return fields.filter(([value, , asked]) => asked && value == null).map(([, label]) => label);
}
